export default [

    {
        name_es: 'Disfruta del desafío',
        name_en: 'Love the challenge',
        id: 1
    },
    {
        name_es: 'Cuenta con otras personas',
        name_en: 'Bring others in',
        id: 2
    },
    {
        name_es: 'Toma la iniciativa',
        name_en: 'Make the call',
        id: 3
    },
    {
        name_es: 'Alcanza la excelencia en equipo',
        name_en: 'Be excellent together',
        id: 4
    }
]
